import React from 'react';
import PropTypes from 'prop-types';
import { CalloutBox, CALLOUTBOX_THEMES } from 'src/components/Elements/CalloutBox';
import styles from '../styles.scss';

const AddSkuV2SkuBullets = ({ sku, className }) => {
  const bullets = sku && sku.getIn(['skuMessagings', 'bullets']);
  if (!bullets || !bullets.size) return null;
  return (
    <CalloutBox
      theme={CALLOUTBOX_THEMES.PRIMARY}
      className={className}
      header="Important"
      text={
        <ul className={styles.bulletsList}>
          {bullets.map((bullet, index) => (
            <li key={`bullet-${index}`}>
              <span className="p2">{bullet}</span>
            </li>
          ))}
        </ul>
      }
    />
  );
};

AddSkuV2SkuBullets.propTypes = {
  sku: PropTypes.object,
  className: PropTypes.string,
};

export default AddSkuV2SkuBullets;
